import { createAsyncThunk } from '@reduxjs/toolkit';

import { AccountService, QuestionnaireService } from 'api';

import { QuizProps } from 'models/form';

export const sendQuiz = createAsyncThunk(
	'questionnaire/sendQuiz',
	async (data: QuizProps, { rejectWithValue }) => {
		try {
			await QuestionnaireService.sendQuiz(data);
			if (data.isAML) {
				return await AccountService.sendInvestmentRisksAgree();
			}
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
